export default "__VITE_ASSET__DNBQ2cOd__"